<template>
  <div class="container">
    <sportTable :list="list" :loading="loading" :remark="true" :iskey="'riskLevelDetailDTOList'" />
  </div>
</template>

<script>
import { getHistoryList } from "@/api/member";
import sportTable from "@/components/sportTable/index";

export default {
  data() {
    return {
      list: [],
      loading: false,
      queryData: {
        riskLevelId: 0
      }
    };
  },
  methods: {
    async getHistoryList() {
      try {
        const res = await getHistoryList(this.queryData);
        const data = res.data || {};
        data.map(item => {
          let selfRisk = item.selfRisk; 
          let dataList = item.riskLevelDetailDTOList || [];
          for (var key in dataList) {
            dataList[key].selfRisk = selfRisk
          }
        })
        this.list = data || [];
      } catch (error) {
        this.list = [];
      }
    }
  },
  components: {
    sportTable
  },
  activated() {
    this.queryData.riskLevelId = this.$route.query.levelId;
    this.getHistoryList();
  },
};
</script>

<style lang="scss" scoped>
/deep/.risk-table {
  .el-table th {
    padding: 6px 0;
  }
}
</style>
